<template>
  <div :class="['editable', isEditingClass, successClass]" :ref="editingId">
    <p v-if="tag == 'p'" :contenteditable="isEditing" @keypress="onInput($event)" @onfocus="focusAllText" ref="editable" @click="startEditing" :id="editingId">{{ displayValue }}</p>
    <h1 v-if="tag == 'h1'" :contenteditable="isEditing" @keypress="onInput($event)" @onfocus="focusAllText" ref="editable" @click="startEditing" :id="editingId">{{ displayValue }}</h1>
    <h2 v-if="tag == 'h2'" :contenteditable="isEditing" @keypress="onInput($event)" @onfocus="focusAllText" ref="editable" @click="startEditing" :id="editingId">{{ displayValue }}</h2>
    <h3 v-if="tag == 'h3'" :contenteditable="isEditing" @keypress="onInput($event)" @onfocus="focusAllText" ref="editable" @click="startEditing" :id="editingId">{{ displayValue }}</h3>
    <div class="edit-actions">
      <div class="disapprove" @click="cancelChanges"> ⃔</div>
      <div class="approve" @click="approveChanges">✔</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Editable',
  components: {
  },
  data() {
    return {
      newValue: null,
      isEditing: 'false',
      show: '',
      successClass: '',
    }
  },
  props: ['conceptId', 'blockId', 'keyName', 'tag', 'value'],
  computed: {
    displayValue(){
      if(this.newValue != null) {
        return this.newValue;
      } else {
        return this.value;
      }
    },
    isEditingClass(){
      if(this.isEditing === 'true') { return 'isEditing' }
      else { return '' }
    },
    editingId(){
      if(this.conceptId){
        return this.conceptId + '-' + this.keyName;
      
      } else {
        return this.blockId + '-' + this.keyName;
      }
      
    },
    editingResult(){
      if(this.$store.state.trust.editingIds[this.editingId]) {
        return this.$store.state.trust.editingIds[this.editingId].result;
      } else {
        return null;
      }
    }
  },
  methods: {
    focusAllText(){
      window.setTimeout(function() {
        var sel, range;
        let el = this.$refs.editable;
        if (window.getSelection && document.createRange) {
            range = document.createRange();
            range.selectNodeContents(el);
            sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        } else if (document.body.createTextRange) {
            range = document.body.createTextRange();
            range.moveToElementText(el);
            range.select();
        }
    }.bind(this), 1);
    },
    onInput(e){
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault();
        this.approveChanges();
      }
    },
    startEditing(){
      // if(this.$store.state.trust.canEdit === true){
        this.isEditing = 'true';
        this.$store.commit('setIsEditing', {newValue: true, editingId: this.editingId});

        setTimeout(function() {
          this.$refs.editable.focus();
          this.focusAllText();
        }.bind(this), 1);
      // }
    },
    approveChanges(){
      this.newValue = this.$refs.editable.innerText;
      
      if(this.conceptId){
        this.$store.commit('updateConcept', { conceptId: this.conceptId, keyName: this.keyName, newValue: this.newValue, editingId: this.editingId });
      
      } else if (this.blockId){
        this.$store.commit('updateBlock', { blockId: this.blockId, keyName: this.keyName, newValue: this.newValue, editingId: this.editingId });
      }
    },
    cancelChanges(){
      this.newValue = null;
      this.isEditing = 'false';
      this.$refs.editable.innerText = this.value;
      setTimeout(function(){
        this.$store.commit('setIsEditing', { newValue: false, editingId: this.editingId });
      }.bind(this), 1)
    },
    finishEditing(){
      this.isEditing = 'false';
    },
  },
  mounted () {
  },
  watch: {
    'editingResult' (to) {
      if(to == 'success'){
        this.successClass = 'editSuccess';
        setTimeout(function(){
          this.successClass = '';
          this.finishEditing();
          if(this.conceptId){
            this.$store.commit('fetchConcepts');            
          } else if (this.blockId){
            this.$store.commit('fetchBlocks');
          }
        }.bind(this), 300);
      }
      
      if(to == 'canceled'){
        this.cancelChanges();
      }
    }
  }
}
</script>
